/* eslint-disable import/no-unresolved */
import { html } from 'lit-all'
/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */

const chevron = html`
  <svg
    aria-hidden="true"
    focusable="false"
    fill="none"
    width="11"
    class="icon icon-chevron-right  icon--direction-aware"
    viewBox="0 0 10 10"
  >
    <path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"></path>
  </svg>
`

const filter = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
  >
    <line
      y1="3.75"
      x2="16"
      y2="3.75"
      stroke="currentColor"
      stroke-width="1.5"
    ></line>
    <line
      y1="10.75"
      x2="16"
      y2="10.75"
      stroke="currentColor"
      stroke-width="1.5"
    ></line>
    <circle
      cx="6.19922"
      cy="3.5"
      r="2.5"
      fill="white"
      stroke="currentColor"
    ></circle>
    <circle
      cx="10.1992"
      cy="10.5"
      r="2.5"
      fill="white"
      stroke="currentColor"
    ></circle>
  </svg>
`

const close = html`
  <svg
    viewBox="0 0 16 16"
    width="16"
    height="16"
    fill="none"
    stroke="currentcolor"
    stroke-width="3"
    style="display:inline-block;vertical-align:middle;overflow:visible;"
  >
    <path
      d="M1.0606601717798212 1.0606601717798212 L14.939339828220179 14.939339828220179"
    ></path>
    <path
      d="M14.939339828220179 1.0606601717798212 L1.0606601717798212 14.939339828220179"
    ></path>
  </svg>
`

const caret = html`
  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6" width="18" height="30">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
  </svg>
`

const play = html`
  <svg
    aria-hidden="true"
    focusable="false"
    role="presentation"
    class="icon icon-play"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM9 17.1962L18 12L9 6.80385L9 17.1962Z"
      fill="currentColor"
    />
  </svg>
`

const pause = html`
  <svg
    aria-hidden="true"
    focusable="false"
    role="presentation"
    class="icon icon-pause"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM7 7H11V17H7V7ZM13 7H17V17H13V7Z"
      fill="currentColor"
    />
  </svg>
`

const search = html`
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    width="24"
    viewBox="0 0 24 24"
  >
    <path
      d="M10.364 3a7.364 7.364 0 1 0 0 14.727 7.364 7.364 0 0 0 0-14.727Z"
      stroke="currentColor"
      stroke-width="1"
      stroke-miterlimit="10"
    />
    <path
      d="M15.857 15.858 21 21.001"
      stroke="currentColor"
      stroke-width="1"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
`

const navigationArrow = html`
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="44" height="44" rx="4" fill="white" />
    <path d="M26 14L34 22L26 30" stroke="#35332B" stroke-linecap="round" />
    <path d="M34 22H10" stroke="#35332B" stroke-linecap="round" />
    <rect x="0.5" y="0.5" width="43" height="43" rx="3.5" stroke="#35332B" />
  </svg>
`
const arrowWithStem = html`
  <svg
    width="26"
    height="18"
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <g id="Group 509">
        <path
          id="Vector 20"
          d="M17 1L25 9L17 17"
          stroke="#35332B"
          stroke-linecap="round"
        />
        <path
          id="Vector 21"
          d="M25 9H1"
          stroke="#35332B"
          stroke-linecap="round"
        />
      </g>
    </g>
  </svg>
`

const plus = html`
  <svg
    aria-hidden="true"
    focusable="false"
    fill="none"
    width="10"
    viewBox="0 0 12 12"
  >
    <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="2" />
  </svg>
`

const minus = html`
  <svg
    aria-hidden="true"
    focusable="false"
    fill="none"
    width="10"
    viewBox="0 0 12 12"
  >
    <path d="M0 6h12" stroke="currentColor" stroke-width="2" />
  </svg>
`

const edit = html`
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.6238 3.2827L9.74983 0.871184L8.71632 2.10287L11.5903 4.51438L12.6238 3.2827ZM11.7955 4.68663L11.6233 4.89191L4.21649 13.719L4.04424 13.9243L3.98412 13.8738L1.20792 14.1167L1.07444 14.1284L1.06276 13.9949L0.819876 11.2187L0.759751 11.1682L0.932002 10.963L8.33879 2.1359L8.51104 1.93062L9.54455 0.698933L9.7168 0.493652L9.92208 0.665903L12.796 3.07742L13.0013 3.24967L12.829 3.45495L11.7955 4.68663ZM8.54407 2.30815L1.13728 11.1352L4.01121 13.5467L11.418 4.71966L8.54407 2.30815ZM1.31804 13.8381L1.11019 11.4623L3.6938 13.6302L1.31804 13.8381Z"
      fill="#55565A"
      stroke="#55565A"
      stroke-width="0.4"
    />
  </svg>
`

const deleteIcon = html`
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4326 1L0.574219 10.8583L10.4326 1Z"
      stroke="#55565A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M10.29 10.8583L0.431641 1L10.29 10.8583Z"
      stroke="#55565A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
`

const zoom = html`
  <svg
    tabindex="-1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g style=""><line x1="11" y1="8" x2="11" y2="14"></line></g>
    <circle cx="11" cy="11" r="7.5"></circle>
    <path d="m21 21-4.35-4.35M8 11h6"></path>
  </svg>
`

const loadingSpinner = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    class="spinner"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5Z"
      fill="#666666"
    />
    <path
      d="M16.8902 5.5863C17.1663 5.10802 17.0025 4.49644 16.5242 4.2203C16.0459 3.94416 15.4343 4.10802 15.1582 4.5863C14.8821 5.06458 15.0459 5.67616 15.5242 5.9523C16.0025 6.22844 16.6141 6.06458 16.8902 5.5863Z"
      fill="#666666"
    />
    <path
      d="M19.4031 8.87989C19.8814 8.60375 20.0453 7.99217 19.7691 7.51389C19.493 7.03561 18.8814 6.87175 18.4031 7.14789C17.9248 7.42403 17.761 8.03561 18.0371 8.51389C18.3133 8.99217 18.9248 9.15603 19.4031 8.87989Z"
      fill="#666666"
    />
    <path
      d="M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11C19.4477 11 19 11.4477 19 12C19 12.5523 19.4477 13 20 13Z"
      fill="#666666"
    />
    <path
      d="M19.7799 16.5249C20.056 16.0466 19.8921 15.435 19.4139 15.1589C18.9356 14.8828 18.324 15.0466 18.0479 15.5249C17.7717 16.0032 17.9356 16.6148 18.4139 16.8909C18.8921 17.167 19.5037 17.0032 19.7799 16.5249Z"
      fill="#666666"
    />
    <path
      d="M16.4851 19.7693C16.9634 19.4932 17.1273 18.8816 16.8511 18.4033C16.575 17.925 15.9634 17.7612 15.4851 18.0373C15.0069 18.3134 14.843 18.925 15.1191 19.4033C15.3953 19.8816 16.0069 20.0454 16.4851 19.7693Z"
      fill="#666666"
    />
    <path
      d="M12 21C12.5523 21 13 20.5523 13 20C13 19.4477 12.5523 19 12 19C11.4477 19 11 19.4477 11 20C11 20.5523 11.4477 21 12 21Z"
      fill="#666666"
    />
    <path
      d="M8.84137 19.4143C9.11752 18.936 8.95365 18.3244 8.47537 18.0483C7.9971 17.7722 7.38552 17.936 7.10938 18.4143C6.83323 18.8926 6.9971 19.5042 7.47537 19.7803C7.95365 20.0564 8.56523 19.8926 8.84137 19.4143Z"
      fill="#666666"
    />
    <path
      d="M5.59647 16.8515C6.07475 16.5754 6.23861 15.9638 5.96247 15.4855C5.68633 15.0072 5.07475 14.8434 4.59647 15.1195C4.11819 15.3956 3.95433 16.0072 4.23047 16.4855C4.50661 16.9638 5.11819 17.1276 5.59647 16.8515Z"
      fill="#666666"
    />
    <path
      d="M4 13C4.55228 13 5 12.5523 5 12C5 11.4477 4.55228 11 4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13Z"
      fill="#666666"
    />
    <path
      d="M5.95173 8.47571C6.22787 7.99743 6.06401 7.38585 5.58573 7.10971C5.10745 6.83356 4.49587 6.99743 4.21973 7.47571C3.94358 7.95398 4.10745 8.56556 4.58573 8.84171C5.06401 9.11785 5.67558 8.95398 5.95173 8.47571Z"
      fill="#666666"
    />
  </svg>
`

const error = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <circle cx="14" cy="14" r="9" stroke="#D0331F" stroke-width="2" />
    <line
      x1="14"
      y1="10"
      x2="14"
      y2="14"
      stroke="#D0331F"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle cx="14" cy="17" r="1" fill="#D0331F" />
  </svg>
`

const dropdownSmall = html`
  <svg
    width="18"
    viewBox="0 0 18 10"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.464535 1.84112C0.160096 1.53668 0.160096 1.04309 0.464535 0.738652C0.768974 0.434213 1.26257 0.434213 1.56701 0.738652L8.71983 7.89148L15.8726 0.738719C16.177 0.434279 16.6706 0.434279 16.9751 0.738719C17.2795 1.04316 17.2795 1.53675 16.9751 1.84119L9.27106 9.54519C8.96662 9.84963 8.47303 9.84963 8.16859 9.54519C8.16769 9.54429 8.1668 9.54339 8.1659 9.54249L0.464535 1.84112Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
`

const sortChevron = html`
  <svg
    viewBox="0 0 17 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M1 0.75L8.5 8.25L16 0.75"
      stroke="currentColor"
      stroke-linecap="round"
    />
  </svg>
`

export {
  chevron,
  filter,
  close,
  caret,
  play,
  pause,
  search,
  navigationArrow,
  plus,
  minus,
  edit,
  deleteIcon,
  zoom,
  loadingSpinner,
  error,
  arrowWithStem,
  dropdownSmall,
  sortChevron,
}
